import React from "react";
import "./Invitation_Rules.css";
import Rules_card from "../Common/Common_Component/Rules_card/Rules_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";

function Invitation_Rules() {
  return (
    <>
      <section className="Invitation_Rules">
        <Common_white_header headingText={"Invitation Rules"} />
        <div className="container">
            <div className="desc_text_hodler">
                <h4>[Promotion Partner] Program</h4>
                <p>this activity is valid for a long time</p>
            </div>

            <Rules_card/>
            <Rules_card/>
            <Rules_card/>
            <Rules_card/>
            <Rules_card/>

             <No_data/>
        </div>
      </section>
    </>
  );
}

export default Invitation_Rules;
